import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const demmurrageReasonStartWith = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/demmurageReason/namestartswith`,
      search,
    );

    const uniqueItems = response.data.filter(
      (item, index, array) =>
        index === array.findIndex((findItem) => findItem.text === item.text),
    );

    return uniqueItems.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const demmurrageDropdown = async (search) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/demmurageReason`,
      search,
    );

    return response.data.filter(
      (item, index, array) =>
        index === array.findIndex((findItem) => findItem.text === item.text),
    );
  } catch (e) {
    console.error(e);
  }
};

export const demmurrageReasonNameById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/demmurageReason/name/${id}`,
    );
    console.log(response.data);
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};
